export { default as AddSquare } from './AddSquare';
export { default as Add } from './Add';
export { default as Additem } from './Additem';
export { default as Archive } from './Archive';
export { default as Arrow3 } from './Arrow3';
export { default as ArrowCircleDown } from './ArrowCircleDown';
export { default as ArrowCircleRight } from './ArrowCircleRight';
export { default as ArrowDown } from './ArrowDown';
export { default as ArrowHorizontal } from './ArrowHorizontal';
export { default as ArrowLeft } from './ArrowLeft';
export { default as ArrowLeft2 } from './ArrowLeft2';
export { default as ArrowRight } from './ArrowRight';
export { default as ArrowRight2 } from './ArrowRight2';
export { default as Box } from './Box';
export { default as Briefcase } from './Briefcase';
export { default as Brush } from './Brush';
export { default as Calendar } from './Calendar';
export { default as CalendarSearch } from './CalendarSearch';
export { default as Call } from './Call';
export { default as Car } from './Car';
export { default as Card } from './Card';
export { default as Category } from './Category';
export { default as ChangeLock } from './ChangeLock';
export { default as Chart } from './Chart';
export { default as Checkbox } from './Checkbox';
export { default as ClipboardClose } from './ClipboardClose';
export { default as ClipboardText } from './ClipboardText';
export { default as Clock } from './Clock';
export { default as CloseCircle } from './CloseCircle';
export { default as CloseSquare } from './CloseSquare';
export { default as Close } from './Close';
export { default as Code } from './Code';
export { default as Colorfilter } from './Colorfilter';
export { default as Company } from './Company';
export { default as CopySuccess } from './CopySuccess';
export { default as Danger } from './Danger';
export { default as DocumentDownload } from './DocumentDownload';
export { default as Document } from './Document';
export { default as DollarCircle } from './DollarCircle';
export { default as Dropdown } from './Dropdown';
export { default as Dropdown2 } from './Dropdown2';
export { default as Earth } from './Earth';
export { default as Edit } from './Edit';
export { default as EyeSlash } from './EyeSlash';
export { default as Eye } from './Eye';
export { default as Filter } from './Filter';
export { default as FlashCircle } from './FlashCircle';
export { default as Flash } from './Flash';
export { default as Forbidden2 } from './Forbidden2';
export { default as GalleryAdd } from './GalleryAdd';
export { default as GalleryEdit } from './GalleryEdit';
export { default as Gallery } from './Gallery';
export { default as Grid } from './Grid';
export { default as Home } from './Home';
export { default as InfoCircle } from './InfoCircle';
export { default as KeyboardOpen } from './KeyboardOpen';
export { default as LampSlash } from './LampSlash';
export { default as LocationAdd } from './LocationAdd';
export { default as Location } from './Location';
export { default as Lock } from './Lock';
export { default as Logout } from './Logout';
export { default as Map } from './Map';
export { default as Menu } from './Menu';
export { default as MessageQuestion } from './MessageQuestion';
export { default as MessageText } from './MessageText';
export { default as MinusSquare } from './MinusSquare';
export { default as Moon } from './Moon';
export { default as More } from './More';
export { default as Next } from './Next';
export { default as NoteAdd } from './NoteAdd';
export { default as Note } from './Note';
export { default as NotificationStatus } from './NotificationStatus';
export { default as Notification } from './Notification';
export { default as People } from './People';
export { default as Personalcard } from './Personalcard';
export { default as Pharagraphspacing } from './Pharagraphspacing';
export { default as Printer } from './Printer';
export { default as ProfileCircle } from './ProfileCircle';
export { default as Refresh } from './Refresh';
export { default as Repeat } from './Repeat';
export { default as SearchNormal } from './SearchNormal';
export { default as Send } from './Send';
export { default as Setting } from './Setting';
export { default as Shop } from './Shop';
export { default as ShoppingCart } from './ShoppingCart';
export { default as Sms } from './Sms';
export { default as Specs } from './Specs';
export { default as Speedometer } from './Speedometer';
export { default as Status } from './Status';
export { default as Sun } from './Sun';
export { default as SupportMessage } from './SupportMessage';
export { default as Tag } from './Tag';
export { default as TaskSquare } from './TaskSquare';
export { default as TickCircle } from './TickCircle';
export { default as TickSquare } from './TickSquare';
export { default as Trash } from './Trash';
export { default as UserRemove } from './UserRemove';
export { default as UserTick } from './UserTick';
export { default as User } from './User';
export { default as Users } from './Users';
export { default as Wallet } from './Wallet';
